import React, { useState, useEffect } from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'

function ProjectType(props) {
    //console.log(props.active)
    return (
        <Box className={'payment-method-summary' + (props.active ? ' active' : '')} onClick={() => props.onClick()}>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1rem' }}>
                        {props.icon}
                    </Box>
                    <Box>
                        <h3>{props.title}</h3>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}

export default ProjectType